// 캐릭터 이관 중 짧은 차단 막(CHARACTER-PRD §13.6): 이관이 도는 몇 초 동안 입력을 막고 "캐릭터를 준비하는 중" 한 줄을 보인다.
// 이관 중 던전에 들어가 원래 키에 쌓인 진행이 캐릭터로 넘어가지 않는 일을 막는다(계정 클라이언트 setBusy 훅). 게임 루프와 무관(DOM만).
let veil: HTMLDivElement | null = null;
const swallow = (e: Event): void => { e.stopImmediatePropagation(); e.preventDefault(); };
// 누르기만 막는다. 떼기(keyup·pointerup·touchend)는 그대로 흘려보낸다 — 막 앞에서 키를 떼도 입력 수집기가 눌림을 풀게(키가 눌린 채 남지 않게, Codex P2 #214)
const EVENTS = ['keydown', 'pointerdown', 'touchstart', 'mousedown', 'click'] as const;

export function setBusyVeil(on: boolean): void {
  if (typeof document === 'undefined') return;
  if (on && !veil) {
    veil = document.createElement('div');
    veil.setAttribute('role', 'status');
    veil.textContent = '캐릭터를 준비하는 중…';
    veil.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(10,12,20,.55);color:#fff;font:600 16px/1.4 system-ui,sans-serif;pointer-events:all';
    document.body.appendChild(veil);
    // 막에 들어갈 때 눌려 있던 입력을 비운다: 창 blur를 보내면 입력 수집기(core/input.ts)가 눌린 키·버튼을 모두 놓는다
    try { if (typeof Event !== 'undefined' && typeof window.dispatchEvent === 'function') window.dispatchEvent(new Event('blur')); } catch { /* 무시 */ }
    for (const t of EVENTS) window.addEventListener(t, swallow, { capture: true });
  } else if (!on && veil) {
    veil.remove();
    veil = null;
    for (const t of EVENTS) window.removeEventListener(t, swallow, { capture: true });
  }
}
